import Vue from 'vue';
import {
  dataUrlRegex,
  ErrorMessages,
  globalPlainUrlRegex,
  globalUrlRegex,
  iframeRegex,
  phoneNumber,
  plainUrlRegex,
  urlAnchorRegex,
  urlRegex,
  zipCode,
} from '../constants';

Vue.mixin({
  methods: {
    capitalizeWords(phrase) {
      if (phrase) {
        const words = phrase.split(' ');
        const capitalizedWords = words.map(word => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        });
        return capitalizedWords.join(' ');
      } else {
        return '';
      }
    },
    capitalizeFirstLetter(text) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
    getFirstLetter(text) {
      return text.charAt(0).toUpperCase();
    },
    scrollToTop() {
      return window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },
    getEmbedUrl(url) {
      const youtubeRegex = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      const vimeoRegex = /(?:vimeo\.com\/(?:.*#|.*\/videos\/)?([0-9]+))/;
      const facebookRegex = /(?:https?:\/\/)?(?:www\.)?facebook\.com\/(?:watch\??v=([a-zA-Z0-9_-]+)|reel\/(\d+))/i;
      // const twitterRegex = /(?:x\.com\/(?:.*\/status\/))([0-9]+)/; TO DO with X API
      const tiktokRegex = /(?:tiktok\.com\/(?:.*\/video\/))([0-9]+)/;
      const instagramRegex = /(?:https?:\/\/(?:www\.)?instagram\.com\/(?:p|reel|reels|tv)\/([\w-]+))/;

      if (youtubeRegex.test(url)) {
        const videoId = url.match(youtubeRegex)[1];
        return `https://www.youtube.com/embed/${videoId}`;
      } else if (vimeoRegex.test(url)) {
        const videoId = url.match(vimeoRegex)[1];
        return `https://player.vimeo.com/video/${videoId}`;
      } else if (facebookRegex.test(url)) {
        const match = url.match(facebookRegex);
        const videoId = match[1];
        const reelId = match[2];

        if (reelId) {
          return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(`https://www.facebook.com/reel/${reelId}`)}&show_text=0`;
        } else if (videoId) {
          return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(`https://www.facebook.com/watch/?v=${videoId}`)}&show_text=0`;
        }
      } else if (tiktokRegex.test(url)) {
        const videoId = url.match(tiktokRegex)[1];
        return `https://www.tiktok.com/embed/v2/${videoId}`;
      } else if (instagramRegex.test(url)) {
        const videoId = url.match(instagramRegex)[1];
        return `https://www.instagram.com/p/${videoId}/embed`;
      } else {
        console.warn('Unsupported video URL format.');
        return null;
      }
    },
    socialMediaName(url) {
      if (url.includes('youtube')) {
        return 'YouTube';
      } else if (url.includes('vimeo')) {
        return 'Vimeo';
      } else if (url.includes('facebook')) {
        return 'Facebook';
      } else if (url.includes('twitter')) {
        return 'Twitter';
      } else if (url.includes('instagram')) {
        return 'Instagram';
      } else if (url.includes('tiktok')) {
        return 'TikTok';
      } else {
        return 'Website';
      }
    },
    cleanUrl(url) {
      return url.replace(/<\/?[a-z][\s\S]*?>/gi, '').replace(/["'>]+$/, '');
    },
    textIncludeUrl(content) {
      const match = content.match(urlRegex);

      let url = null;
      if (match) {
        url = this.cleanUrl(match[1]);
      } else {
        const plainMatch = content.match(plainUrlRegex);
        if (plainMatch) {
          url = this.cleanUrl(plainMatch[0]);
        }
      }

      return url;
    },
    getAllUrls(content) {
      let matches = [...content.matchAll(globalUrlRegex)];
      if (matches.length === 0) {
        matches = [...content.matchAll(globalPlainUrlRegex)];
        if (matches.length === 0) return [];
        return matches.map(match => this.cleanUrl(match[0]));
      }
      return matches.map(match => this.cleanUrl(match[1]));
    },
    isVideoEmbed(text) {
      const match = text.match(iframeRegex);
      return match;
    },
    hasDataUrl(text) {
      const dataUrlMatch = text.match(dataUrlRegex);
      return dataUrlMatch;
    },
    isAnchorTag(text) {
      const urlMatch = text.match(urlAnchorRegex);
      return urlMatch;
    },
    removeContentUrl(content) {
      return content.replace(/<a[^>]*>(.*?)<\/a>/gi, '');
    },
    handleImageError(event) {
      event.target.src = 'https://assets.crowdblue.com/v2/production/all/img/imageNotFound.png';
    },
    validatePhone(value) {
      if (!value) {
        return ErrorMessages.REQUIRED;
      } else if (!phoneNumber.test(value)) {
        return ErrorMessages.VALID_PHONE_NUMBER;
      } else if (value.trim().length === 0) {
        return ErrorMessages.NOT_BLANK_MESSAGE;
      } else {
        return '';
      }
    },
    validateZip(value) {
      if (!value) {
        return ErrorMessages.REQUIRED;
      } else if (!zipCode.test(value)) {
        return ErrorMessages.VALID_POSTAL_CODE_NUMBER;
      } else if (value.trim().length === 0) {
        return ErrorMessages.NOT_BLANK_MESSAGE;
      } else {
        return '';
      }
    },
    validateInput(value) {
      if (!value) {
        return ErrorMessages.REQUIRED;
      } else if (value.trim().length === 0) {
        return ErrorMessages.NOT_BLANK_MESSAGE;
      } else {
        return '';
      }
    },
    lobbySubject(type, politicianName) {
      if (type == 'endorse') {
        return 'Constituent message endorsing ' + politicianName;
      } else if (type == 'oppose') {
        return 'Constituent message in opposition to ' + politicianName;
      }
    },
    lobbyBody(user, type, politicianName) {
      if (user && type == 'endorse') {
        return `Dear ${politicianName},

                As your constituent, I want to thank you for the direction of your policies and leadership.

                I believe the positions you’ve taken reflect the values and priorities of our community. Please continue to stand up for what matters to regular people and invest in a better future.

                Sincerely,
                ${user.name}`;
      } else if (user && type == 'oppose') {
        return `Dear ${politicianName},

                As your constituent, I want to express my concern about the direction of your policies and priorities.

                I don't feel that your positions reflect the needs or values of people like me in our community. I urge you to reconsider your approach and make decisions that better support regular people and invest in our future.

                Regards,
                ${user.name}`;
      }
    },
    formatOfficeName(officeName) {
      const match = officeName.match(/^(U\.S\. (?:House|Senate)) (.+)$/);
      if (match) {
        return `${match[1]} | <span class="primary-color">${match[2]}</span>`;
      }
      return officeName;
    },
  },
});
